// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_gc-3";
export var flatBottomCorners = "_gc-5";
export var productImage = "_gc-0";
export var quantityContainer = "_gc-2";
export var quantityHeader = "_gc-6";
export var tooltip = "_gc-1";
export var wrapAndEllipsesOverflow = "_gc-4";